/**
 * Decodes HTML entities and special characters in a string
 * @param {string} text - The text to decode
 * @returns {string} The decoded text
 */
export const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') return text;

  return (
    text
      // Convert numeric HTML entities
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      // Convert hex HTML entities
      .replace(/&#x([0-9A-F]+);/gi, (match, hex) => String.fromCharCode(parseInt(hex, 16)))
      // Convert named HTML entities
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&ndash;/g, '–')
      .replace(/&mdash;/g, '—')
      .replace(/&nbsp;/g, ' ')
      .replace(/&copy;/g, '©')
      .replace(/&reg;/g, '®')
      .replace(/&trade;/g, '™')
  );
};

/**
 * Encodes special characters to HTML entities
 * @param {string} text - The text to encode
 * @returns {string} The encoded text
 */
export const encodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') return text;

  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};
